import React from "react";
import { Slider } from "./components/Slider";
import img01 from "./img/img-01.webp";
import img02 from "./img/img-02.webp";
import { Reviews } from "./components/Reviews";
import { AboutUs } from "./components/AboutUs";
import { ProductionProcess } from "./components/Production";

const swiperImages = [
  {
    image: img01,
    title: "МАСТЕРСКАЯ",
    titleContinuous: "ИНТЕРЬЕРНЫХ РЕШЕНИЙ",
    subtitle: "вы можете у нас:",
    btn: "рассчитать стоимость",
    path: "calculator",
  },
  {
    image: img02,
    title: "МАСТЕРСКАЯ",
    titleContinuous: "ИНТЕРЬЕРНЫХ РЕШЕНИЙ",
    subtitle: "вы можете у нас:",
    btn: "рассчитать стоимость",
    path: "materials",
  },
];

export const MainPage = ({ isHomePage }) => {
  return (
    <div>
      <Slider swiperImages={swiperImages} />
      <AboutUs isHomePage={true}/>
      <ProductionProcess isHomePage={true}/>
      <Reviews/>
    </div>
  );
};
